import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAfterTideAuth } from '../../context/AfterTideAuthContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
const AgeGate = () => {
  const {
    verify
  } = useAfterTideAuth();
  const navigate = useNavigate();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const handleConfirm = () => {
    verify();
    navigate('/aftertide');
  };
  const handleReturn = () => {
    navigate('/');
  };
  return <div className={`min-h-screen ${dk.page} flex flex-col items-center justify-center p-4 relative overflow-hidden selection:bg-[#c77dba] selection:text-[#1a1a2e]`} data-id="element-4634" data-mp="3lorc3obm7o5s">
      <style data-id="element-4635" data-mp="3col2idj1f8bw">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap');
          .font-playfair { font-family: 'Playfair Display', serif; }
        `}
      </style>

      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c77dba] opacity-[0.03] blur-[100px] rounded-full pointer-events-none" data-id="element-4636" data-mp="oagmypixdcho" />

      <div className={`max-w-md w-full ${dk.surface}/80 backdrop-blur-sm p-10 rounded-2xl border ${dk.borderAccent} shadow-2xl relative z-10 text-center`} data-id="element-4637" data-mp="y963adv6aovt">
        <h1 className={`font-playfair text-5xl font-bold ${rt.textPrimary} mb-4 tracking-wide`} data-id="element-4638" data-mp="tc60cbtme28x">
          AfterTide
        </h1>

        <div className="w-12 h-px bg-[#e2b04a]/50 mx-auto mb-6" data-id="element-4639" data-mp="12bjc5b57v2wt" />

        <p className={`${dk.textPrimary} text-lg mb-2 font-medium`} data-id="element-4640" data-mp="1gznwejjx3mhp">
          Mature Fiction.
        </p>
        <p className={`${dk.textSecondary} text-sm mb-10 leading-relaxed`} data-id="element-4641" data-mp="1c0ksx3jl5obu">
          Transparent Classification. Reader Control.
        </p>

        <div className="space-y-8" data-id="element-4642" data-mp="1q158lqu7f414">
          <div data-id="element-4643" data-mp="1pxzjiblks25e">
            <p className={`${dk.textPrimary} text-sm mb-6`} data-id="element-4644" data-mp="1lyqnf032bs6o">
              This section of the store contains explicit adult content. You
              must be 18 years or older to enter.
            </p>
            <button onClick={handleConfirm} className={`w-full ${rt.primaryButton} font-bold py-3.5 px-6 rounded-lg transition-all duration-200 transform hover:-translate-y-0.5 shadow-[0_0_15px_rgba(226,176,74,0.3)]`} data-id="element-4645" data-mp="1y0s1vsh79th3">
              I confirm I am 18 or older
            </button>
          </div>

          <div className={`pt-6 border-t ${dk.border}`} data-id="element-4646" data-mp="2brn1sf9q108j">
            <button onClick={handleReturn} className={`${dk.textSecondary} hover:text-[#f5f0e8] text-sm font-medium transition-colors`} data-id="element-4647" data-mp="2gr9g6s1acmix">
              Return to LitLaunch
            </button>
          </div>
        </div>
      </div>

      <div className={`absolute bottom-8 text-center px-4 max-w-2xl ${dk.textSecondary}/60 text-xs`} data-id="element-4648" data-mp="2qnmigeawc8pa">
        <p data-id="element-4649" data-mp="wbobyk3z1qx3">
          By entering, you agree to our Terms of Service and acknowledge that
          you are legally permitted to view adult content in your jurisdiction.
          AfterTide operates independently from LitLaunch.
        </p>
      </div>
    </div>;
};
export default AgeGate;